import { STATUS, CHARGE_STATUS, RETURN_STATUS } from "@/lib/constants";

const Pill = ({ cls, children, testId }) => (
  <span data-testid={testId} className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-semibold ${cls}`}>
    {children}
  </span>
);

export const StatusBadge = ({ status, testId }) => {
  const s = STATUS[status] || STATUS.agendado;
  return (
    <Pill cls={s.badge} testId={testId}>
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />
      {s.label}
    </Pill>
  );
};

export const ChargeBadge = ({ status, testId }) => {
  const s = CHARGE_STATUS[status] || CHARGE_STATUS.pendente;
  return <Pill cls={s.badge} testId={testId}>{s.label}</Pill>;
};

export const ReturnBadge = ({ status, testId }) => {
  const s = RETURN_STATUS[status] || RETURN_STATUS.sem_data;
  return <Pill cls={s.badge} testId={testId}>{s.label}</Pill>;
};

export const TagBadge = ({ children, testId }) => (
  <Pill cls="bg-cyan-50 text-cyan-700 border-cyan-200" testId={testId}>{children}</Pill>
);
